import { render, staticRenderFns } from "./MessageContextMenu.vue?vue&type=template&id=70bb9568&scoped=true"
import script from "./MessageContextMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageContextMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MessageContextMenu.vue?vue&type=style&index=0&id=70bb9568&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bb9568",
  null
  
)

export default component.exports